import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MenuMain = makeShortcode("MenuMain");
const MenuBlock = makeShortcode("MenuBlock");
const Link = makeShortcode("Link");
const SocialLinks = makeShortcode("SocialLinks");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MenuMain style={{
      borderBottom: 'black',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      padding: 10
    }} mdxType="MenuMain">
  <MenuBlock mdxType="MenuBlock">
    <Link to="/" style={{
          fontSize: 28
        }} mdxType="Link">clayton marshall</Link>
  </MenuBlock>
  <MenuBlock mdxType="MenuBlock">
   <SocialLinks fontSize={20} mdxType="SocialLinks" />
  </MenuBlock>
    </MenuMain>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      